'use strict';

import angular from 'angular';
import 'bootstrap-daterangepicker';
import './commonDirectives';
import './commonServices';
import './commonFilters';
import './mapService';

/**
 * @ngdoc overview
 * @name commonModule
 * @description
 * # commonModule
 * Module for commons
 */
const commonModule = angular.module('commonModule', [
    'commonModule.commonDirectives',
    'commonModule.commonFilters',
    'commonModule.commonServices',
    'commonModule.mapService'
]);

commonModule.constant(
    'DATE_FORMAT', {
        'SHORT': 'L',
        'FULL': 'L LT',
        'URL': 'YYYY-MM-DD',
        'API': 'YYYY-MM-DD HH:mm:ss',
        'API_SHORT': 'YYYY-MM-DD',
        'CHART': 'YYYY-MM-DD HH:NN',
        'CHART_SHORT': 'YYYY-MM-DD'
    });

commonModule.value('dateRangePickerConfig', {
    separator: ' - ',
    format: 'L'
});

export default commonModule;
